import { render, staticRenderFns } from "./BbeeTarifadosT.vue?vue&type=template&id=c23fe61a"
import script from "./BbeeTarifadosT.vue?vue&type=script&lang=js"
export * from "./BbeeTarifadosT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports